<template>
  <div>
    <mdb-modal
      removeBackdrop
      centered
      @close="$store.commit('clearCurrentModal')"
      elegant
    >
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue"
          >Can’t find the location you're looking for?</mdb-modal-title
        >
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="mb-4 mt-n3">
          If the location you are looking for is not listed in the Test Studio
          Finder, here you can add a placeholder studio with the desired country
          / city to your request list.
        </p>
        <form v-on:submit.prevent>
          <div class="grey-text">
            <mdb-input
              class="mt-4"
              type="text"
              label="Country"
              icon="globe-europe"
              v-model.trim="country"
              outline
            />
            <mdb-input
              class="mt-4"
              type="text"
              label="City (optional)"
              icon="map-marker-alt"
              v-model.trim="city"
              outline
            />
          </div>
          <validation-info :text="validationInfo" />
          <div class="text-center">
            <mdb-btn
              class="mt-4"
              color="isi"
              @click="addCustomLocationToRequestList"
              >ADD TO REQUEST LIST</mdb-btn
            >
          </div>
        </form>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
import ValidationInfo from "../ValidationInfo.vue";

export default {
  name: "CustomLocationsModal",
  components: {
    ValidationInfo,
  },
  data() {
    return {
      country: "",
      city: "",
      validationInfo: "",
    };
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  methods: {
    addCustomLocationToRequestList() {
      if (!this.country) {
        this.validationInfo = "Please fill out the country field.";
        return;
      }
      this.$http({
        method: "POST",
        url: "/api/CustomLocation/AddToRequestList",
        data: {
          customLocationWriteDTO: {
            country: this.country,
            city: this.city,
          },
          testType: this.options.testType,
        },
      })
        .then((rsp) => {
          console.log(rsp);
          if (rsp.data?.err) {
            this.validationInfo = rsp.data.err;
            return;
          }

          if (rsp.data.changedRequestListTestType) {
            this.$store.commit("setRequestListTestType", {
              testType: this.options.testType,
            });
          }

          this.$store.commit("addCustomLocationToRequestList", {
            customLocation: rsp.data.customLocation,
          });

          let displayName = this.country;
          if (this.city) displayName += " (" + this.city + ")";

          this.$store.commit("setCurrentModal", {
            type: "generalInfoModal",
            options: {
              title: "Custom location added",
              content:
                'The location "' +
                displayName +
                '" has been added to your request list.',
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
</style>